export const related = [
  '/quests/power-lines',
  '/guides/build-power',
  '/quests',
];
export const quickAnswer =
  'Escort the probe relays, clear the encounters, place and activate all four relays, then use the new escape platforms and follow the music.';
export const sourceIds = ['powerpyx-sinkhole', 'powerpyx-quests'];

## Into the Sinkhole Requirements

This Contain the Crisis mission follows Arish’s Briefing. The Sinkhole is in Evacuation Zone.

## Probe Relay Objectives

Use the descending probe's control after each encounter. At the bottom, carry each relay to its marked destination; the green light confirms placement. Activate the back of each placed relay.

## How to Escape the Sinkhole

Finish the encounter after installing all four relays. The platforms that appear provide the climb out. Follow the illuminated cord, and wait for the rotating refraction to open before crossing.

## How to Follow the Music

At the top, follow the illuminated televisions playing music until you reach the outside.

## Common Stuck Points

A placed relay still needs activation. If the escape route is absent, check remaining enemies. If the final route seems unclear, follow the television cues instead of retracing the descent.

## What Unlocks Next

Completion advances the questline. Check remaining journal objectives and [Power Lines](/quests/power-lines) for parallel progress.
